/**
 * Method to get the style of the information name
 * displayed in the used car drawer collapse.
 * @returns {{ marginBottom: number }} — CSS style.
 */
export const getUsedCarDrawerCollapseInformationNameStyle =
	() => {
		return {
			marginBottom: "var(--zero-margin)",
		};
	};

/**
 * Method to get the style of the information textual
 * value displayed into the used car drawer collapse.
 * @returns {{marginTop: number}} — CSS style.
 */
export const getUsedCarDrawerCollapseInformationTextStyle =
	() => {
		return {
			marginTop: "var(--zero-margin)",
		};
	};
